export default "__VITE_ASSET__DgWmEZno__"